module.exports = __webpack_public_path__ + "img/vbf.09f6319e.png";